import { render, staticRenderFns } from "./ConfigAlertAlerta.vue?vue&type=template&id=7ba36c16&scoped=true"
import script from "./ConfigAlertAlerta.vue?vue&type=script&lang=js"
export * from "./ConfigAlertAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba36c16",
  null
  
)

export default component.exports